import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="transformstreamdefaultcontroller" id="transformstreamdefaultcontroller"></a>
    <h1 {...{
      "id": "windowtransformstreamdefaultcontroller"
    }}>{`window.TransformStreamDefaultController`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/TransformStreamDefaultController"
      }}>{`Web APIs - TransformStreamDefaultController`}</a>{`  `}</p>
    <a name="transformstreamdefaultcontroller-desiredsize" id="transformstreamdefaultcontroller-desiredsize"></a>
    <h2 {...{
      "id": "desiredsize--number"
    }}>{`desiredSize : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Returns the desired size to fill the readable side’s internal queue.
It can be negative, if the queue is over-full.`}</p>
    <a name="transformstreamdefaultcontroller-enqueue" id="transformstreamdefaultcontroller-enqueue"></a>
    <h2 {...{
      "id": "enqueuechunk"
    }}>{`enqueue(chunk)`}</h2>
    <p>{`Enqueues the given chunk chunk in the readable side of the controlled transform stream.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the stream is not readable.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`chunk`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The chunk being queued. A chunk is a single piece of data.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="transformstreamdefaultcontroller-error" id="transformstreamdefaultcontroller-error"></a>
    <h2 {...{
      "id": "errorreason"
    }}>{`error(reason)`}</h2>
    <p>{`Errors both the readable side and the writable side of the controlled transform stream,
making all future interactions with it fail with the given error.
Any chunks queued for transformation will be discarded.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="transformstreamdefaultcontroller-terminate" id="transformstreamdefaultcontroller-terminate"></a>
    <h2 {...{
      "id": "terminate"
    }}>{`terminate()`}</h2>
    <p>{`Closes the readable side and errors the writable side of the controlled transform stream.
This is useful when the transformer only needs to consume a portion of the chunks written to the writable side.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      